export default "__VITE_ASSET__57eed041__"